import { gql } from '@apollo/client';

export const getWurRankingData = gql`
  query GetRankData(
    $year: Int!
    $institutionId: String!
    $level1Id: String!
    $releaseName: String!
    $responseFields: [ResponseFieldsListItem!]
  ) {
    release(
      year: $year
      level1Id: $level1Id
      institutionId: $institutionId
      releaseName: $releaseName
      responseFields: $responseFields
    ) {
      institutionData {
        countryRank
      }
      level1 {
        result {
          rank {
            higher
            lower
          }
          jointRanked
        }
      }
    }
  }
`;

export const wurRankingDataQuery = (year: number, institutionId: string) => ({
  variables: {
    year: Number.isInteger(year) ? year : new Date().getFullYear(),
    institutionId,
    level1Id: 'overall',
    releaseName: 'wur',
    responseFields: ['INSTITUTIONDATA'],
  },
});
